// Faction-specific auto-generated names — funny and degrading in the
// in-group way, not offensive. Virgin names lean into nerdy/shut-in/weeb
// self-deprecation. Chad names lean into cringe vanity / sponcon
// / hustle culture. Both pools are 50 entries.
//
// The auto-picker hashes the device id so returning players get the
// same name across sessions — just like the old `autoName` did.

import type { Role } from './net/protocol';

export const VIRGIN_NAMES: ReadonlyArray<string> = [
  'HikikomoriHero',
  'BodyPillowBob',
  'ClosedTabCollector',
  'DiscordMod42',
  'LonelySub27',
  'BasementDweller',
  'UwUOverlord',
  'AnimeArchivist',
  'SweatshirtSage',
  'DarkRoomDan',
  'VtuberVassal',
  'PlushPile',
  'WaifuWarden',
  'LastGenGamer',
  'KeyboardSage',
  'UnreadEmailGoblin',
  'EnergyDrinkVoid',
  'BedroomBard',
  'TabHoarder',
  'ThermostatTinkerer',
  'ShowerlessSaint',
  'TwoMonthStreak',
  'ForgottenPassword',
  'BackRowBuddy',
  'MangaStacker',
  'ChairWarrior',
  'LurkerLord',
  'ScreensaverSam',
  'CRTCrusader',
  'NightModeKnight',
  'LoFiLurker',
  'DarkThemeOnly',
  'IdleAFKer',
  'ContentEater',
  'TrophyRoomTadashi',
  'ShonenShutIn',
  'ReplyGuy99',
  'LofiNapper',
  'SteamSaleSlayer',
  'EmoticonPriest',
  'BinaryBandit',
  'ColdTakeoutKazu',
  'OneMoreTurnOtis',
  'ShyPatchNoter',
  'PixelHoarder',
  'ForumNecromancer',
  'StreakKeeper',
  'UnwashedHoodie',
  'RedditGoldAcolyte',
  'OfflineEnjoyer',
];

export const CHAD_NAMES: ReadonlyArray<string> = [
  'ClickbaitCleo',
  'FiveStarFraud',
  'BrandAmbassador99',
  'HashTagHero',
  'SponConQueen',
  'GymSelfieGreg',
  'LinkInBio',
  'EngagementFarmer',
  'RingLightRuler',
  'ProteinPusher',
  'ViralVince',
  'AffiliateAlex',
  'MorningRoutineMaven',
  'ManifestMax',
  'BottleCoachBecca',
  'CollabOrDie',
  'DMSlider',
  'BookTokBeliever',
  'MicroChadMax',
  'CameraRollCleo',
  'GoldenHourGary',
  'HydrateHannah',
  'SelfCareSerena',
  'PodcastPaul',
  'ProductPlacePete',
  'StoryChainSophia',
  'TikTokTrent',
  'WellnessWanda',
  'WhiteboardWes',
  'ClarityCarl',
  'GratefulGabby',
  'SmoothieBowlSally',
  'CrystalCoach',
  'OptimizeOliver',
  'LifeHackLana',
  'QRCoachQuinn',
  'MomPreneur',
  'DadPreneur',
  'DiscoveryDan',
  'AlgorithmAnnie',
  'ThirstyTrap',
  'UnboxingUma',
  'VibeCheckVera',
  'ContentMachine',
  'GlowUpGina',
  'BrandDaddy',
  'SixFigureSeb',
  'NicheNerd',
  'CaptionKing',
  'HustleHarper',
];

// Deterministic hash — returning players get the same name across
// sessions. Mirrors the old autoName() in team_picker.ts.
function hashDevice(deviceId: string): number {
  let h = 0;
  for (let i = 0; i < deviceId.length; i++) {
    h = ((h * 31) + deviceId.charCodeAt(i)) >>> 0;
  }
  return h;
}

export function autoNameForRole(role: Role, deviceId: string): string {
  const pool = role === 'int' ? VIRGIN_NAMES : CHAD_NAMES;
  const h = hashDevice(deviceId || 'anon');
  return pool[h % pool.length];
}

// Non-deterministic reroll — used by the dice button in the team picker.
// Picks a random name from a randomly-chosen faction pool.
export function rollRandomName(): { name: string; role: Role } {
  const role: Role = Math.random() < 0.5 ? 'int' : 'ext';
  const pool = role === 'int' ? VIRGIN_NAMES : CHAD_NAMES;
  const name = pool[Math.floor(Math.random() * pool.length)];
  return { name, role };
}
